import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getXssFilter } from '../../../helpers/helpers';

class ConfirmationContent extends Component {
    render() {

        if (!this.props.content) {
            return null;
        }

        return (
            <div className="confirmation__content">
                <div className="rich-content__body" dangerouslySetInnerHTML={this.getContent()}></div>
            </div>
        )
    }

    getContent = () => {
        return {__html: getXssFilter().process(this.props.content)};
    }
}

ConfirmationContent.propTypes = {
    content: PropTypes.string,
}

export default ConfirmationContent;
